import YICUClassPage from "./YICUClassPage";

const CONTENT = {
  winnerPhotos: [
    { src: "/images/YICU/2024/YICU-Winners2.png", caption: "2024 YICU Individual Winners (Top Row): Jacob Kossler, Dhruv Ravinuthala, Disha Rai, Kamorah Carter, Sohum Mehta. (Bottom Row): Emily Drew, Shreya Nallamothu, Amy Dederich, Joshitha Bodavula, Shriyans Gurijala" },
    { src: "/images/YICU/2024/YICU-Winners1.png", caption: "2024 YICU Special Award Winners" },
  ],
  winners: [
    { label: "Individual Winners (10)", color: "pink", items: ["Jacob Kossler", "Dhruv Ravinuthala", "Disha Rai", "Kamorah Carter", "Sohum Mehta", "Emily Drew", "Shreya Nallamothu", "Amy Dederich", "Joshitha Bodavula", "Shriyans Gurijala"] },
    { label: "Team Award", color: "purple", items: ["2025 NCHS IT Cohort — Nikitha Philip, Dhyan Chaudhari, Megan Heidrick, Vedha Garapati, Lillian Campbell, Carson Goodwin and Logan Jaynes"] },
    { label: "Youth Mentor Award", color: "green", items: ["Sudhir Pai"] },
    { label: "Advocate Award", color: "purple", items: ["Threshold to Hope Inc."] },
    { label: "Standing Ovation & Community Hero Award", color: "pink", items: ["Brandon Wood", "Shriyans Gurijala"] },
  ],
};

export default function Yicu2024() {
  return <YICUClassPage year="2024" logoSrc="/images/YICU/2024/YICU2024.png" content={CONTENT} />;
}